<template>
	<div class="mhn">
		<div class="mhn__overlay" @click="hiddenModal"></div>

		<!-- Modal window -->
		<div class="mhn__modal">
			<!-- /////////////////// -->
			<!-- Firs row -->
			<div class="mhn__modal-row">
				<div class="mhn__modal-row-icon">
					<IconArrowLeftDown />
				</div>
				<div class="mhn__modal-row-message">
					<div class="mhn__modal-row-message_text">
						Покупка каналов
					</div>
					<div class="mhn__modal-row-message_date">
						20 февраля в 09:17
					</div>
				</div>
				<div class="mhn__modal-row-price_minus">-500 руб.</div>
			</div>

			<!-- /////////////////// -->
			<!-- Second row -->
			<div class="mhn__modal-row">
				<div class="mhn__modal-row-icon">
					<IconPlus />
				</div>
				<div class="mhn__modal-row-message">
					<div class="mhn__modal-row-message_text">
						Пополнение баланса
					</div>
					<div class="mhn__modal-row-message_date">
						20 февраля в 09:17
					</div>
				</div>
				<div class="mhn__modal-row-price_plus">+1500 руб.</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconArrowLeftDown from "@/components/icons/IconArrowLeftDown.vue";
import IconPlus from "@/components/icons/IconPlus.vue";
import { mapActions } from "vuex";
import { IModal } from "@/interfaces/IModal";

@Options({
	components: { IconPlus, IconArrowLeftDown },
	methods: {
		...mapActions("instanceModule", ["modalNotifyAction"]),
	},
})
export default class ModalHeaderNotify extends Vue {
	// ************************************************************
	// Define mapActions
	public modalNotifyAction!: (payload: IModal) => void;

	/**
	 * Скрывает модальное окно
	 */
	public hiddenModal() {
		this.modalNotifyAction({ isShow: false });
	}
}
</script>

<style scoped lang="scss">
.mhn {
	padding: 0 16px;
	&__overlay {
		display: block;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	&__modal {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		padding: 12px 6px;
		min-width: 300px;
		background-color: rgb(255, 255, 255);
		border-radius: 12px;
		border: 1px solid rgb(223, 230, 238);
		box-shadow: 0 4px 0 -4px rgba(16, 24, 64, 0.04);
		z-index: 2;
	}

	&__modal-row {
		display: grid;
		grid-template-columns: 50px 200px 80px;
		gap: 2px;
		padding: 12px;
		align-items: center;
	}

	&__modal-row-message {
		display: flex;
		flex-direction: column;
	}

	&__modal-row-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		background: rgb(244, 246, 250);
		border-radius: 50%;
	}

	&__modal-row-message_text {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__modal-row-message_date {
		font-size: 14px;
		color: rgb(119, 121, 124);
	}

	&__modal-row-price_minus {
		font-size: 16px;
		color: rgb(49, 49, 50);
	}

	&__modal-row-price_plus {
		font-size: 16px;
		color: rgb(0, 210, 55);
	}

	@media screen and (max-width: 768px) {
		&__modal {
			display: block;
			margin-top: -5px;
			left: 16px;
			right: 16px;
		}

		&__modal-row {
			grid-template-columns: 0.15fr 0.59fr 0.29fr;
		}
	}

	@media screen and (min-width: 768px) {
	}

	// Анимация
	animation-duration: 0.4s;
	animation-name: appearance-animation-modal;
}
@keyframes appearance-animation-modal {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
